import React, { useState, useEffect } from 'react';
import CalendarPicker from '@/components/CalendarPicker/CalendarPicker';

const QuestionDate = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const required = !!question.required;

  const [, setDatePickerIsOpen] = useState(false);
  const handleDateChange = (date) => {
    if (!previewOnly) {
      setAnswer(date || null);
    }
  };

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(!required || answer);
    }
  }, [answer, previewOnly]);

  return (
    <CalendarPicker
      selectedDate={answer}
      onDateChange={handleDateChange}
      showMonthDropDown={true}
      maximumDate={new Date()}
      setDatePickerIsOpen={setDatePickerIsOpen}
      showYearDropDown={true}
      dropDownMode="select"
      showError={true}
      disabled={previewOnly}
    />
  );
};

export default QuestionDate;
